import { useEffect } from 'react';

export default function useScrollTop() {
  useEffect(() => {
    document.documentElement.scroll(0, 0);
  }, []);
}
